import React, { useEffect, useState, useCallback, useContext } from "react";
import { useLocation } from "react-router-dom";
import "./style.scss";
import Router from "../../routes";
import Header from "../Header";
import Sidebar from "../Sidebar";
import RechargeWallet from "../../components/RechargeWallet";
import { Modal } from "antd";
import { UserWalletContext } from "../../context/userWalletContext";

const Layout = () => {
  const location = useLocation();
  const [showHeader, setShowHeader] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [handleSideBar, setHandleSideBar] = useState(false);

  const {
    openRechargeWalletModal,
    setOpenRechargeWalletModal,
    selectedOrderForPayment,
    setSelectedOrderForPayment,
  } = useContext(UserWalletContext);

  useEffect(() => {
    const currentPath = location.pathname;

    if (
      ["/login", "/forgot-password", "/signup", "/adaptation-view"].includes(
        currentPath
      )
    ) {
      setShowHeader(false);
      setShowSidebar(false);
      document.body.classList.add("authentication_wrapper");
    } else if (currentPath.includes("/adaptation-view")) {
      setShowHeader(true);
      setShowSidebar(false);
      document.body.classList.add("adaptation_wrapper");
    } else {
      setShowHeader(true);
      setShowSidebar(true);
      document.body.classList.remove("authentication_wrapper");
      document.body.classList.remove("adaptation_wrapper");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600 && window.innerWidth <= 700) {
        setHandleSideBar(false);
      } else {
        setHandleSideBar(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window]);

  const handleToggle = useCallback(() => {
    setHandleSideBar((prevState) => !prevState);
  }, []);

  const getRechargeWallet = () => {
    return (
      <Modal
        open={openRechargeWalletModal}
        footer={null}
        width="400px"
        height="542px"
        centered
        className="recharge_wallet_wrapper"
        onCancel={() => {
          setOpenRechargeWalletModal(false);
          setSelectedOrderForPayment();
        }}
      >
        <RechargeWallet order={selectedOrderForPayment} />
      </Modal>
    );
  };

  return (
    <div className="layout_wrapper">
      {showSidebar && (
        <div className={handleSideBar ? "sidebar_wrapper" : "hide_sidebar"}>
          <Sidebar handleToggle={handleToggle} />
        </div>
      )}
      <div
        className={
          showHeader && handleSideBar
            ? "content_wrapper_container"
            : "content_large_container"
        }
      >
        {showHeader && <Header />}
        <div className="router_wrapper">
          <Router />
        </div>
      </div>
      {openRechargeWalletModal && getRechargeWallet()}
    </div>
  );
};

export default Layout;
